import React from 'react'
import logo from "../Files/IBG Logo single  white.svg";

interface Props { }

function Load(props: Props) {

    return (
        <div className='ibg-loader' role="status" aria-label="IBG Alpha Technology">
            <span className='ibg-loader__mark'><img src={logo} alt="" /></span>
            <span className='ibg-loader__bar' />
        </div>
    )
}

export default Load
